import React, { useEffect, useState } from 'react';
import { db } from '../firebase';
import { collection, getDocs } from 'firebase/firestore';

export const NewsletterSubscriptions = () => {
  const [subscriptions, setSubscriptions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSubscriptions = async () => {
      setLoading(true);
      try {
        const subscriptionsCollection = collection(db, 'newsletter_subscriptions');
        const subscriptionsSnapshot = await getDocs(subscriptionsCollection);
        const subscriptionsList = subscriptionsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setSubscriptions(subscriptionsList);
      } catch (error) {
        console.error("Error fetching subscriptions: ", error);
      }
      setLoading(false);
    };

    fetchSubscriptions();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <h1 className="display-lg mb-8" style={{ color: 'var(--text-primary)' }}>Newsletter Subscriptions</h1>
      <div className="overflow-x-auto">
        <table className="min-w-full" style={{ background: 'var(--bg-secondary)', border: '1px solid var(--border-subtle)' }}>
          <thead>
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider" style={{ color: 'var(--text-secondary)' }}>Email</th>
              <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider" style={{ color: 'var(--text-secondary)' }}>Subscribed At</th>
            </tr>
          </thead>
          <tbody style={{ color: 'var(--text-primary)' }}>
            {subscriptions.map((subscription) => (
              <tr key={subscription.id} style={{ borderTop: '1px solid var(--border-subtle)' }}>
                <td className="px-6 py-4 whitespace-nowrap">{subscription.email}</td>
                <td className="px-6 py-4 whitespace-nowrap">{subscription.subscribed_at?.toDate().toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};